<template>
    <div id="containerApp" class="container-top" v-loading.fullscreen.lock="loading"
         :class="[{'none-scroll' : !isAuth()},{'full-page' : $route.path === '/auth/register' || $route.path === '/auth/register/partner'}] ">
        <background-component v-if="isAuth()"></background-component>
        <div class="container-center" :class="[{'auth' : isAuth()},]">
            <router-view/>
        </div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import BackgroundComponent from "@/components/BackgroundComponent.vue";
import MobileDetect from "mobile-detect";
import {isDev, isBeta, isCbt} from "@/api/config";
import branchMixins from "@/mixins/branchMixins";

export default {
    name: "App",
    mixins: [branchMixins],
    components: {
        BackgroundComponent,

    },
    provide() {
        return {
            changeLoading: this.changeLoading,
        }
    },
    props: {},
    data() {
        return {
            passPath: ['/auth/register'],
            loading: false,
            loadingText: '',

        }
    },
    async created() {
        let md = new MobileDetect(window.navigator.userAgent);
        if (md.mobile() !== null) {
            //추후 추가
            // 약관 단독 페이지는 카카오 동의창 등 외부에서 모바일로 열리므로 경로를 보존해 전환한다
            const path = location.pathname.startsWith('/auth/register/terms/') ? location.pathname : '/';
            if (isCbt) {
                location.href = 'https://mcbt.cmbrainbowtv.co.kr' + path
            } else if (isBeta) {
                location.href = 'https://mbeta.cmbrainbowtv.co.kr' + path
            } else if (isDev) {
                location.href = 'https://mdev.cmbrainbowtv.co.kr' + path
            } else {
                location.href = 'https://m.cmbrainbowtv.co.kr' + path
            }

        }
        let token = this.$localStorage.get('token');
        if (!util.isEmpty(token)) {
            this.$store.dispatch('userInfo/setUserInfo', {token});
        }
        await this.checkSnsStatistics();
    },
    mounted() {
        EventBus.$on('changeLoading', this.changeLoading);
        EventBus.$on('apiLoading', this.changeLoading);

    },
    beforeDestroy() {
        EventBus.$off('changeLoading')
        EventBus.$off('apiLoading')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        async checkSnsStatistics(){
            let snsCode = await this.checkRouteSnsCode();
            if(snsCode != null) {
                let localLink = this.$localStorage.get('snsLink',);
                if(localLink != snsCode.code){
                    this.$localStorage.set('snsLink', snsCode.code);
                }
                this.$api.$sns.sendSnsEnter({
                    seDevice: 2,
                    sclUrl: snsCode.code,
                });
            }
        },
        isAuth() {
            if (this.$route.meta.background) {
                return true
            }
        },

        changeLoading(value, text = '') {
            this.loading = value;
            if (!value) {
                this.loadingText = '';
            } else {
                this.loadingText = text;
            }
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(true);
                }, 50)
            })
        },
        checkLink(){
            let outerParams = new URLSearchParams(window.location.search);
            let redirect = outerParams.get('redirect');
            if (redirect) {
                let decodedRedirect = decodeURIComponent(redirect);
                let innerQuery = decodedRedirect.split('?')[1];
                let innerParams = new URLSearchParams(innerQuery);
                let snsKey = innerParams.get('csk');
                if (snsKey) {
                    let link = `https://rainbowtv.app.link/?csk=${snsKey}`;
                    this.$localStorage.set('snsLink', link);
                    this.$api.$sns.sendSnsEnter({
                        seDevice: 2,
                        sclUrl: link,
                    });
                }
            }
        },
    },
    watch: {},
}
</script>

<style lang="scss">
@import "./assets/scss/index.scss";
</style>
